//import {URLSearchParams} from '@angular/http';

export class SolrRequestDTO  {
    static readonly PARAMETER_Q = 'q'; // Solr main search parameter
    static readonly PARAMETER_FQ = 'fq[]'; // Solr query filtration parameter
    static readonly PARAMETER_FACET = 'facet';
    static readonly PARAMETER_FACET_MINCOUNT = 'facet.mincount';
    static readonly PARAMETER_FACET_FIELD = 'facet.field[]';
    static readonly PARAMETER_FACET_PIVOT = 'facet.pivot[]';
    static readonly PARAMETER_FACET_SORT = 'facet.sort';
    static readonly PARAMETER_FACET_OFFSET = 'facet.offset';
    static readonly PARAMETER_FACET_LIMIT = 'facet.limit';
    static readonly PARAMETER_FACET_RANGE = 'facet.range';
    static readonly PARAMETER_FACET_RANGE_START = 'facet.range.start';
    static readonly PARAMETER_FACET_RANGE_END = 'facet.range.end';
    static readonly PARAMETER_FACET_RANGE_GAP = 'facet.range.gap';
    static readonly PARAMETER_ROWS = 'rows';
    static readonly PARAMETER_START = 'start';
    static readonly PARAMETER_GROUP = 'group';
    static readonly PARAMETER_GROUP_FIELD = 'group.field';
    static readonly PARAMETER_GROUP_NGROUPS = 'group.ngroups';
    static readonly PARAMETER_GROUP_LIMIT = 'group.limit';
    static readonly PARAMETER_GROUP_SORT = 'group.sort';
    static readonly PARAMETER_STATS = 'stats';
    static readonly PARAMETER_STATS_FIELD = 'stats.field';
    static readonly PARAMETER_SORT = 'sort';
    static readonly PARAMETER_QF = 'qf'; // DisMax/EDisMax Query Fields
    static readonly PARAMETER_DEF_TYPE = 'defType'; // Query parser
    static readonly PARAMETER_SYNONYMS = 'synonyms';
    static readonly PARAMETER_SYNONYMS_IGNORE_QUERY_OPERATORS = 'synonyms.ignoreQueryOperators';
    static readonly PARAMETER_Q_OP = 'q.op';
    static readonly PARAMETER_FL = 'fl[]';
    static readonly PARAMETER_JSON_FACET = 'json.facet';
    static readonly PARAMETER_DEBUG_QUERY = 'debugQuery';
    static readonly PARAMETER_BQ = 'bq';
    static readonly PARAMETER_HL = 'hl';
    static readonly PARAMETER_HL_FIELD = 'hl.fl';
    static readonly PARAMETER_HL_MT = 'hl.highlightMultiTerm';
    static readonly VALUE_Q_OP_AND = 'AND';
    static readonly PARAMETER_F_QF = 'f.search.qf';
    static readonly PARAMETER_F_SEARCH = ' AND search:';
    static readonly PARAMETER_SOLR_SEARCH = 'solr_search';

    params: Array<any> = [];
    //searchParams: URLSearchParams = new URLSearchParams(); // UrlSearchParams doesn't support multiple query params with the same name

    addQueryParameter(name, value) {
        this.params.push(name + '=' + value);
    }

    paramsToString() {
        return this.params.join('&');
    }

}
